'use client'

import { cn } from '@/lib/utils';
import React, { useEffect, useState } from 'react'

interface IAdSterraBannerProp {
    position: 'top' | 'middle1' | 'middle2' | 'middle3' | 'bottom'
} 

function AdSterraIFrameBannerAuto({ position }: IAdSterraBannerProp) {

    const [isDesktop, setIsDesktop] = useState<boolean | null>(null);

    const adHTML728x90 = `
        <!DOCTYPE html>
        <html>
        <head>
        <style>
            body { margin: 0; padding: 0; overflow: hidden; }
        </style>
        </head>
        <body>
        <script type="text/javascript">
            atOptions = {
            'key': 'b7ebcbad1f522bd05497ca147399be09',
            'format': 'iframe',
            'height': 90,
            'width': 728,
            'params': {}
            };
        </script>
        <script type="text/javascript" src="https://www.highperformanceformat.com/b7ebcbad1f522bd05497ca147399be09/invoke.js"></script>
        </body>
        </html>
    `;

    const adHTML728x90Middle = `
        <!DOCTYPE html>
        <html>
        <head>
        <style>
            body { margin: 0; padding: 0; overflow: hidden; }
        </style>
        </head>
        <body>
        <script type="text/javascript">
            atOptions = {
            'key': '8a827cae66dd62d1057dd79ddd98b7f7',
            'format': 'iframe',
            'height': 90,
            'width': 728,
            'params': {}
            };
        </script>
        <script type="text/javascript" src="https://www.highperformanceformat.com/8a827cae66dd62d1057dd79ddd98b7f7/invoke.js"></script>
        </body>
        </html>
    `;

    const adHTML320x250 = `
        <!DOCTYPE html>
        <html>
        <head>
        <style>
            body { margin: 0; padding: 0; overflow: hidden; }
        </style>
        </head>
        <body>
        <script type="text/javascript">
            atOptions = {
            'key': '4d621f1ae561376f7ac494f8178f3f6e',
            'format': 'iframe',
            'height': 250,
            'width': 320,
            'params': {}
            };
        </script>
        <script type="text/javascript" src="https://www.highperformanceformat.com/4d621f1ae561376f7ac494f8178f3f6e/invoke.js"></script>
        </body>
        </html>
    `;
    
    useEffect(() => {
        // 1. Function to evaluate current screen size and inject the correct ad
        const handleResolutionAndInject = () => {
            const currentIsDesktop = window.innerWidth >= 768;

            setIsDesktop(currentIsDesktop);

            if (currentIsDesktop) {
                const desktopContainer = document.getElementById(`ad-desktop-slot-${position}`);

                // Only inject if it's completely empty so we don't multiply ads
                if (desktopContainer && desktopContainer.childElementCount === 0) {
                    const iframe = document.createElement('iframe');
                    iframe.srcdoc = position.startsWith('middle') ? adHTML728x90Middle : adHTML728x90;
                    iframe.width = '728';
                    iframe.height = '90';
                    iframe.style.border = 'none';
                    iframe.style.overflow = 'hidden';
                    
                    desktopContainer.appendChild(iframe);
                }
            } else {
                // Setup Mobile Config
                const mobileContainer = document.getElementById(`ad-mobile-slot-${position}`);
                // Only inject if it's completely empty
                if (mobileContainer && mobileContainer.childElementCount === 0) {
                    const iframe = document.createElement('iframe');
                    iframe.srcdoc = adHTML320x250;
                    iframe.width = '320';
                    iframe.height = '250';
                    iframe.style.border = 'none';
                    iframe.style.overflow = 'hidden';
                    
                    mobileContainer.appendChild(iframe);
                }
            } 
        };

        // 2. Run immediately on initial page mount
        handleResolutionAndInject();

        // 3. Set up an event listener to catch window resizing and phone rotation
        window.addEventListener('resize', handleResolutionAndInject);

        // 4. Clean up the event listener when the component unmounts to prevent memory leaks
        return () => {
        window.removeEventListener('resize', handleResolutionAndInject);
        };


    }, []);

  return (
    <div className={cn('w-full flex justify-center items-center', position != 'top' ? 'mt-4 mb-4' : 'mt-2 mb-2')} id='adSterra-ad-container'>
      {/* <div id="adsterra-container" style={{ width: '728px', height: '90px' }}></div> */}
      {/* DESKTOP BANNER: Hidden on mobile, flex centered on medium screens and up */}
      <div id={`ad-desktop-slot-${position}`} className="hidden md:block" style={{ width: '728px', height: '90px' }} />
      <div id={`ad-mobile-slot-${position}`} className="block md:hidden" style={{ width: '320px', height: '250px' }} />
    </div>

  )
}

export default AdSterraIFrameBannerAuto;
